
interface HistoryPage<T> {
    page: T,
    onSuspend: ()=>void
}

export enum PageNavigationType { Push, Replace, Pop }


function newHistoryPage<T>(page: T, onSuspend: ()=>void): HistoryPage<T> {
    return {
        page: page,
        onSuspend: onSuspend
    }
}

export type PageNavigationCallback<T> = (newNav: HistoryPage<T>, navType: PageNavigationType) => Promise<void>

export class PageNavigator<T> {
    navStack: HistoryPage<T>[];
    
    onNavigate: PageNavigationCallback<T>

    constructor(onNavigate?: PageNavigationCallback<T> ) {
        this.navStack = [];
        this.onNavigate = onNavigate;
    }

    currentNav: () => HistoryPage<T> = () => {
        return this.navStack.length > 0 ? this.navStack[this.navStack.length - 1] : null;
    }

    navigatePush: (page: T, onSuspend?: ()=>void) => Promise<void> = (page, onsuspend=null) => {
        let currentPage = this.currentNav();

        if (currentPage && currentPage.onSuspend) {
            currentPage.onSuspend()
        }

        let historyPage = newHistoryPage(page, onsuspend)
        this.navStack.push(historyPage)
        return this.doNavigate(PageNavigationType.Push)
    }

    replace: (page: T, onSuspend?: ()=>void) => void = (page, onsuspend=null) => {
        this.navStack.pop();
        let historyPage = newHistoryPage(page, onsuspend)
        this.navStack.push(historyPage)
    }

    navigateReplace: (page: T, onSuspend?: ()=>void) => Promise<void> = (page, onsuspend=null) => {
        this.replace(page, onsuspend);
        return this.doNavigate(PageNavigationType.Replace)
    }

    navigatePop: () => Promise<void> = () => {
        if (!this.currentNav())
            return;
        this.navStack.pop()
        return this.doNavigate(PageNavigationType.Pop)
    }
    
    doNavigate(direction: PageNavigationType): Promise<void> {
        let currentNav = this.currentNav();

        if (!this.onNavigate) return Promise.resolve();

        return this.onNavigate(currentNav, direction)
    }

}

